import type { Produto } from '../db/tipos'

// Pedido dela 30/09: dois codigos iguais na mesma fornecedora nao podem existir.
// O servidor ja recusa (idx_produtos_codigo_unico, representada_id + codigo),
// mas o app gravava no aparelho e o produto ficava preso em "O que nao subiu".
// Aqui um pouco mais rigido que o indice: ignora espaco e maiuscula (medido em
// 30/09: 0 repetidos assim no banco).
const chave = (s: string) => s.trim().toLowerCase()

export function codigoRepetido(
  produtos: Pick<Produto, 'id' | 'representada_id' | 'codigo' | 'apagado_em'>[],
  representadaId: string, codigo: string, idAtual: string | undefined,
): Pick<Produto, 'id' | 'representada_id' | 'codigo' | 'apagado_em'> | undefined {
  if (chave(codigo) === '') return undefined
  return produtos.find((p) =>
    p.apagado_em === null && p.id !== idAtual && p.representada_id === representadaId && chave(p.codigo) === chave(codigo))
}
